import React, { useState, useMemo, useCallback } from 'react';
import { TreeSelect, Spin } from 'antd';
import { connect } from 'react-redux';
import { labelsOnPartsRestCrudThunksForSupplier } from '../../thunks/labels_thunks';
import LabelDisplay from '../LabelDisplay';
import { Label } from '../../types/labels';
import useMountEffect from '../../hooks/useMountEffect';

const { SHOW_PARENT } = TreeSelect;

const LabelsDropdown = ({
	value,
	onChange,
	mode,
	allowClear = true,
	style,
	placeholder,
	disabled,
	tagRender,
	labels,
	fetchAllLabels,
}) => {
	const [allLabels, setAllLabels] = useState<Label[]>([]);
	const [fetched, setFetched] = useState(false);

	useMountEffect(() => {
		fetchAllLabels().then((result) => {
			setAllLabels(result);
			setFetched(true);
		});
	});

	const treeData = useMemo(() => {
		const selectedIds = Array.isArray(value) ? value : value ? [value] : [];
		const selectedRecords = selectedIds
			.map((id) => labels.records[id])
			.filter((record) => record && record.id);

		const allRecordIds = new Set(allLabels.map((label) => label.id));
		const merged = [
			...selectedRecords.filter((record) => !allRecordIds.has(record.id)),
			...allLabels,
		];

		return merged.map((label) => ({
			value: label.id,
			key: label.id,
			title: <LabelDisplay tag={label} />,
			filterText: label.label || '',
		}));
	}, [allLabels, value, labels.records]);

	const handleChange = useCallback(
		(selectedValues) => {
			if (onChange) {
				onChange(selectedValues);
			}
		},
		[onChange]
	);

	return (
		<TreeSelect
			virtual={false}
			multiple={mode === 'multiple'}
			treeCheckable={mode === 'multiple'}
			showCheckedStrategy={SHOW_PARENT}
			treeDefaultExpandAll
			notFoundContent={!fetched ? <Spin size="small" /> : null}
			placeholder={placeholder}
			showSearch
			treeNodeFilterProp="filterText"
			onChange={handleChange}
			treeData={treeData}
			style={style}
			allowClear={allowClear}
			value={value}
			disabled={disabled || (!fetched && treeData.length === 0)}
			tagRender={tagRender}
		/>
	);
};

const mapStateToProps = (state) => ({
	labels: state.labels,
});

const mapDispatchToProps = (dispatch) => ({
	fetchAllLabels: () =>
		dispatch(
			labelsOnPartsRestCrudThunksForSupplier.readLite({ no_pagination: true }, 'labelsDropdown')
		),
});

export default connect(mapStateToProps, mapDispatchToProps)(LabelsDropdown);
